<template lang="pug">
include verification.pug
</template>

<script>
import Loader from '@/components/shared/loader'
import Notification from '@/components/shared/notification'
import SwitchButton from '@/components/shared/switchButton'
import { createNamespacedHelpers } from 'vuex'
import { actionTypes, mutationTypes } from '@/store/verification'

const { mapState: mapGlobalState } = createNamespacedHelpers('globals')
const verificationStore = createNamespacedHelpers('verification')
const oidcStore = createNamespacedHelpers('oidc')

export default {
  name: 'VerificationView',
  components: {
    Loader,
    Notification,
    SwitchButton
  },
  data: function () {
    return {
      isSubmitting: false
    }
  },
  computed: {
    ...verificationStore.mapState({
      loader: (state) => state.loader,
      children: (state) => state.children,
      drivingLicenseCases: (state) => state.drivingLicenseCases,
      anyPending: (state) => state.children.concat(state.drivingLicenseCases).some((i) => !i.isLocked),
      anySelected: (state) =>
        state.children
          .concat(state.drivingLicenseCases)
          .filter((i) => !i.isLocked)
          .some((i) => i.status !== undefined),
      allSelected: (state) =>
        state.children
          .concat(state.drivingLicenseCases)
          .filter((i) => !i.isLocked)
          .every((i) => i.status !== undefined)
    }),
    ...mapGlobalState({
      texts: (state) => state.texts.childApplicationAcceptance,
      drivingLicenseTexts: (state) => state.texts.drivingLicenseApplicationAcceptance,
      landingTexts: (state) => state.texts.guardianVerificationLanding
    }),
    anyItems: function () {
      return this.children.length > 0 || this.drivingLicenseCases.length > 0
    },
    anyPassportItems: function () {
      return this.children.length > 0
    },
    anyDrivingLicenseItems: function () {
      return this.drivingLicenseCases.length > 0
    }
  },
  mounted: function () {
    this.loadChildren()
  },
  methods: {
    ...verificationStore.mapMutations({
      setStatus: mutationTypes.SET_STATUS,
      setDrivingLicenseStatus: mutationTypes.SET_DRIVING_LICENSE_STATUS
    }),
    ...verificationStore.mapActions({
      loadChildren: actionTypes.LOAD_CHILDREN,
      submit: actionTypes.SUBMIT
    }),
    ...oidcStore.mapActions({
      signOut: 'signOutOidc'
    }),
    trySubmit: function () {
      this.isSubmitting = true

      if (this.allSelected) {
        this.submit()
        this.isSubmitting = false
      }
    },
    cancelSubmitting: function () {
      this.isSubmitting = false
    },
    continueSubmitting: function () {
      this.submit()
      this.isSubmitting = false
    }
  }
}
</script>
